module.exports = __webpack_public_path__ + "static/media/image-feedback@3x.ea03aeaf.png";